@let entry = inspectionEntry();
<div class="inspection-entry-list-item"
     [id]="entry.value.cid"
     [class.selected]="selected()"
     [ngClass]="getInspectionEntryStatusFromFormGroup(entry)">
  <div class="marker-slot">
    @if (markedForPostProcessing()) {
      <nb-icon icon="bookmark"
               pack="eva"
               status="warning"
               [class.clickable]="canEdit()"
               [nbTooltip]="canEdit() ? 'Für die Nachbearbeitung markiert. Klicken zum Entfernen.' : 'Für die Nachbearbeitung markiert.'"
               (click)="onMarkPostProcessingDoneClick($event)"></nb-icon>
    }
  </div>
  <div class="number">
    <span>{{ entry.controls.checkpointGroupNumber.value }}</span>
    <span>.</span>
    <span>{{ entry.controls.checkpointNumber.value }}</span>
  </div>
  <div class="status-icons">
    @if (isImminentDanger()) {
      <div nbTooltip="Gefahr im Verzug" nbTooltipStatus="danger">
        <nb-icon status="danger" icon="alert-triangle-outline" pack="eva"></nb-icon>
      </div>
    }
    @if (equipmentCount(); as count) {
      <div class="tga-icon" nbTooltip="Hat {{ count }} {{ count | pluralize:'TGA':'TGAs' }}">
        <nb-icon icon="cube" pack="fas"></nb-icon>
        <span>{{ count }}</span>
      </div>
    } @else if (tgaRelevant()) {
      <div class="tga-icon" nbTooltip="TGA relevant, keine TGA zugewiesen">
        <nb-icon status="info" icon="cube" pack="fas"></nb-icon>
      </div>
    }
    @if (inspectionContext.repairTasksVisible() && inspectionContext.hasRepairTask(entry.value!.id!)) {
      <div nbTooltip="hat Reperaturauftrag">
        <nb-icon status="info" icon="screwdriver-wrench" pack="fas"></nb-icon>
      </div>
    }
  </div>
  <div class="name">{{ entry.controls.checkpointName.value }}</div>
  <div class="spacer"></div>
  @if (entry.controls.comments.controls.length) {
    <div class="comments">
      <nb-icon pack="eva" icon="message-circle-outline"></nb-icon>
      <span>{{ entry.controls.comments.controls.length }}</span>
    </div>
  }
</div>
